import React, { useEffect, useState } from "react";
import Dashboard from "../../dashboard/Dashboard";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchReviewsByStatus,
  listLanguageToTeach,
} from "../../../services/review.service";
import {
  LanguageToTaught,
  LanguageToTeachResponse,
  ReviewsStatus,
} from "../types";
import showToast from "../../../utils/show.toast";
import formatDate from "../../../utils/date.formater";
import { LanguageReviewType } from "../../../utils/constants";

interface ILanguageToTaught {
  isLoading: boolean;
  languageToTaught: LanguageToTaught[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function LanguageToTeachTable() {
  const [languageToTaught, setTeachLanguages] = useState<ILanguageToTaught>({
    isLoading: true,
    languageToTaught: [],
  });

  const query = useQuery();
  const status = query.get("status") as ReviewsStatus;

  const fetchLanguageToTeach = async () => {
    try {
      const endpoint = `teachers/language-update?category=${LanguageReviewType.TEACH}&status=${status}`;
      const response = await fetchReviewsByStatus<LanguageToTeachResponse>(
        endpoint
      );

      if (response.status === "success") {
        setTeachLanguages({
          isLoading: false,
          languageToTaught: response.result,
        });
      } else {
        showToast(response.message || "Failed to fetch languages", false);
      }
    } catch (err: any) {
      showToast(err?.message || "An error occurred", false);
    }
  };

  useEffect(() => {
    fetchLanguageToTeach();
  }, []);

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const sortedRequests = [...languageToTaught.languageToTaught].sort(
    (a, b) => a.id - b.id
  );

  return (
    <Dashboard pageTitle="Language To Teach">
      <div className={style.languagePage}>
        {/* Total Students Count */}
        <div className={style.counterCard}>
          <div className={style.titleTwrapper}>
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              onClick={handleBackClick}
              className={style.backIcon}
            />
            <h2>Language To Teach</h2>
          </div>
        </div>

        {/* Language to Teach Table */}
        <div className={style.pageTable}>
          {languageToTaught.isLoading ? (
            <p
              className={style.textStyle}
              style={{ marginTop: "2px", marginBottom: "3px" }}
            >
              Loading Requests...
            </p>
          ) : (
            <table>
              <>
                <thead>
                  <tr>
                    {/* <th>ID</th> */}
                    <th>Email</th>
                    <th>Requested At</th>
                  </tr>
                </thead>
                <tbody style={{ cursor: "pointer" }}>
                  {sortedRequests.map((request) => (
                    <tr
                      key={request.id}
                      onClick={() =>
                        (window.location.href = `/review/language-to-teach/${request.id}/details?status=${status}`)
                      }
                    >
                      {/* <td>{request.id}</td> */}
                      <td>{request.teacher.email}</td>
                      <td>
                        {" "}
                        {formatDate((request?.requestedAt as any) ?? null)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
            </table>
          )}
        </div>
      </div>
    </Dashboard>
  );
}
